import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Button, Glyphicon } from '@bingads-webui-react/primitive';
import {
  expressionTokenProp,
  providesProps,
  sharedProps,
  noopFactory,
} from '@bingads-webui-react/hoc-with-expression-editor-controls';

export class SegmentSelector extends React.PureComponent {
  static propTypes = {
    categories: sharedProps.segmentCategories.isRequired,
    className: PropTypes.string,
    i18n: PropTypes.shape({ getString: PropTypes.func.isRequired }).isRequired,
    onSegmentChangedFactory: providesProps.onSegmentChangedFactory,
    selectedToken: expressionTokenProp,
  };

  static defaultProps = {
    className: 'custom-column-segment-selector',
    onSegmentChangedFactory: noopFactory,
    selectedToken: null,
  };

  constructor(props) {
    super(props);

    const { categories, selectedToken } = props;
    const initialState = {};
    const selectedSegmentInfo = selectedToken && selectedToken.segments ?
      selectedToken.segments : {};
    const selectedCategory = selectedSegmentInfo.categoryValue;
    if (selectedCategory) {
      initialState[selectedCategory] = true;
    } else {
      const { category } = _.first(categories);
      initialState[category] = true;
    }

    this.state = initialState;
  }

  toggleCategory = (category) => {
    this.setState((state) => {
      const newState = {};

      newState[category] = !state[category];
      return newState;
    });
  };

  render() {
    const {
      categories,
      className,
      i18n,
      onSegmentChangedFactory,
      selectedToken,
    } = this.props;
    let checkboxes;

    if (selectedToken) {
      const selectedSegmentInfo = selectedToken.segments || {};
      const selectedCategory = selectedSegmentInfo.categoryValue;

      checkboxes = _.map(categories, ({
        category,
        segments,
        titleKey: categoryTitleKey,
      }, index) => {
        const enabled = _.isEmpty(selectedCategory) || category === selectedCategory;
        const categoryTitle = i18n.getString(categoryTitleKey);
        let selectableOptions;
        const expanded = this.state[category];

        if (expanded) {
          selectableOptions = _.map(segments, ({
            segment,
            titleKey: segmentTitle,
          }, innerIndex) => {
            const title = i18n.getString(segmentTitle);
            const segmentInfo = {
              categoryValue: category,
              categoryTitle,
              value: segment,
              title,
            };
            const checked = _.contains(_.pluck(selectedSegmentInfo.selections, 'value'), segment);

            return (
              <Checkbox
                checked={checked}
                disabled={!enabled}
                key={`${index}-${innerIndex}`}
                onChange={onSegmentChangedFactory(segmentInfo)}
                title={title}
                value={segment}
              >
                {title}
              </Checkbox>
            );
          });
        }

        return (
          <div key={`${index}-${categoryTitleKey}`}>
            <Button
              btnStyle="link"
              onClick={() => this.toggleCategory(category)}
              aria-expanded={expanded ? 'true' : 'false'}
            >
              <Glyphicon glyph={expanded ? 'ba-ChevronDown' : 'ba-ChevronRight'} />
              {categoryTitle}
            </Button>
            <div>
              {selectableOptions}
            </div>
          </div>
        );
      });
    }

    const content = checkboxes ? (
      <React.Fragment>
        <div className="segmentation-header">
          {i18n.getString('CustomColumnExpressionEditor_SegmentFor')} <strong>{selectedToken.title}</strong>
        </div>
        <div id={`${className}-interactive-area`}>
          {checkboxes}
        </div>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <div>
          {i18n.getString('CustomColumnExpressionEditor_Segment_Label')}
        </div>
        <div>
          {i18n.getString('CustomColumnExpressionEditor_Segment_Direction')}
        </div>

      </React.Fragment>
    );

    return (
      <div className={className}>
        {content}
      </div>
    );
  }
}
